import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { MarkdownReaderContainer } from '@/shared/components/ui/markdown-reader/markdown-reader.styled';
import { TMarkdownReaderProps } from '@/shared/components/ui/markdown-reader/markdown-reader.types';

export const MarkdownReader: React.FC<TMarkdownReaderProps> = ({ content }) => {
  return (
    <MarkdownReaderContainer>
      <ReactMarkdown
        children={content}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
      />
    </MarkdownReaderContainer>
  );
};
